import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-secondary-200/70 text-foreground-800" aria-label="页脚">
      <div className="container-x py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-display text-xl font-bold text-foreground-900">漫画网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              漫画网首页直达漫画网收录漫画大全，按漫画网漫画库、漫画网漫画分类、漫画网漫画目录快速定位。想看哪部直接进列表，收录范围一次全看清，畅享漫画阅读乐趣。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-tiktok-fill"].map((ic) => (
                <a
                  key={ic}
                  href="#"
                  rel="nofollow"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                  aria-label="社交平台"
                >
                  <i className={`${ic} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Categories */}
          <nav aria-label="漫画分类链接">
            <h3 className="text-sm font-bold text-foreground-900">漫画分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link to={`/category/${c.id}`} className="text-foreground-700 transition-colors hover:text-primary-600">
                    {c.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Site links */}
          <nav aria-label="站内导航">
            <h3 className="text-sm font-bold text-foreground-900">快速直达</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-foreground-700 hover:text-primary-600">首页</Link></li>
              <li><Link to="/category/all" className="text-foreground-700 hover:text-primary-600">全部漫画</Link></li>
              <li><Link to="/category/all?sort=views" className="text-foreground-700 hover:text-primary-600">排行榜</Link></li>
              <li><Link to="/about" className="text-foreground-700 hover:text-primary-600">关于我们</Link></li>
            </ul>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-200/70 pt-6 text-xs text-foreground-600 sm:flex-row">
          <p>© 2026 漫画网 ManhuaWang. 收录漫画仅供阅读交流，版权归原作者所有。</p>
          <p>
            备案号：<a href="#" rel="nofollow" className="hover:text-primary-600">京ICP备XXXXXXXX号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}